window.Money = {
  format(cents, format = null) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    
    let formatString = format || window.theme?.moneyFormat || '${{amount}}';
    let decimals = parseInt(window.theme?.moneyDecimals ?? '2', 10);
    
    if (decimals === 0) {
      cents = Math.floor(cents / 100) * 100;
      formatString = formatString.replace('{{amount}}', '{{amount_no_decimals}}');
      formatString = formatString.replace('{{ amount }}', '{{ amount_no_decimals }}');
    }
    
    const valueNum = cents / 100;

    if (typeof format === 'string' && format.includes('{{')) {
      formatString = format;
    }

    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, formatString);
    }
    
    // Fallback simple formatter if window.Shopify.formatMoney is not available
    const valueStr = valueNum.toFixed(decimals);
    const valueStrWithCommas = valueStr.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatMatch = formatString.match(placeholderRegex);
    
    if (formatMatch) {
      switch (formatMatch[1]) {
        case 'amount':
          return formatString.replace(placeholderRegex, valueStrWithCommas);
        case 'amount_no_decimals':
          return formatString.replace(placeholderRegex, valueNum.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'));
        case 'amount_with_comma_separator':
          return formatString.replace(placeholderRegex, valueStrWithCommas.replace(/\./g, '-').replace(/,/g, '.').replace(/-/g, ','));
        case 'amount_no_decimals_with_comma_separator':
          return formatString.replace(placeholderRegex, valueNum.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.'));
        case 'amount_no_decimals_with_space_separator':
          return formatString.replace(placeholderRegex, valueNum.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 '));
        case 'amount_with_space_separator':
          return formatString.replace(placeholderRegex, valueStrWithCommas.replace(/,/g, ' '));
        case 'amount_with_apostrophe_separator':
          return formatString.replace(placeholderRegex, valueStrWithCommas.replace(/,/g, "'"));
        default:
          return formatString.replace(placeholderRegex, valueStrWithCommas);
      }
    }

    // Default formatting if no placeholder found
    const symbol = window.theme?.currencySymbol || '$';
    return symbol + valueStrWithCommas;
  }
};
